import { render, staticRenderFns } from "./QuestionsInfo.vue?vue&type=template&id=0289c2c6&"
import script from "./QuestionsInfo.vue?vue&type=script&lang=js&"
export * from "./QuestionsInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports